import { useQuery } from '@tanstack/react-query';

import useApi from '../use-api';

import type {
  ISmsCampaignsProgressFilters,
  ISmsCampaignsData,
} from 'infrastructure/interfaces';

const apiUrl = 'core-2/patients/sms-campaign/progress';

export const useSmsCampaignsData = (filters: ISmsCampaignsProgressFilters) => {
  const filter = structuredClone(filters);
  delete filter.patientKey;
  const queryKey = [apiUrl, filter] as const;

  const pageSize = 100;

  const { loadData } = useApi();

  const emptyStatistics = {
    completed: 0,
    pending: 0,
    sent: 0,
    total: 0,
  };

  const { data, error, isLoading, isPreviousData, refetch } = useQuery({
    queryKey,
    keepPreviousData: true,
    queryFn: async () => {
      const res = await loadData<
        ISmsCampaignsData,
        ISmsCampaignsProgressFilters
      >(apiUrl, {
        ...filter,
        items: pageSize,
      });
      return res;
    },
    enabled: Boolean(filters.campaignGuid),
  });

  return {
    data: {
      data: data?.data ?? [],
      count: data?.count ?? 0,
      statistics: data?.statistics ?? emptyStatistics,
    },
    isLoading: isLoading || isPreviousData,
    error,
    isPreviousData,
    pageSize,
    refetch,
  };
};
